import * as styles from "./styles.css";
export const MastHeadTags = ({ customAttrTag, mastHeadTagColor, }) => {
    return (customAttrTag && (React.createElement("span", { className: styles.tags, style: {
            background: `#${mastHeadTagColor}`,
        } }, customAttrTag)));
};

